import { Provider } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
//import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { DateConfigService } from '../services/date-config.service';
import { AppDateAdapter } from './app-date-adapter';

//  moment date formats that match our native formats - not using moment at the moment
// export const APP_MOMENT_DATE_FORMATS = {
//   parse: {
//     dateInput: 'MM/DD/YYYY',
//   },
//   display: {
//     dateInput: 'MM/DD/YYYY',
//     monthYearLabel: 'MMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY',
//   },
// };

// Native date formats
export const APP_NATIVE_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/dd/yyyy',
  },
  display: {
    dateInput: 'MM/dd/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

export type DateAdapterType = 'native' | 'moment';

// Provide native adapter
export function provideNativeDateConfiguration(locale: string = 'en-US'): Provider[] {
  return [
    DateConfigService,
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
      deps: [DateConfigService]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_NATIVE_DATE_FORMATS
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: locale
    }
  ];
}

// Provide moment adapter - no, removed moment, not ESM, use native or date-fns
// export function provideMomentDateConfiguration(locale: string = 'en-US'): Provider[] {
//   return [
//     DateConfigService,
//     {
//       provide: DateAdapter,
//       useClass: AppMomentDateAdapter,
//       deps: [DateConfigService]
//     },
//     {
//       provide: MAT_DATE_FORMATS,
//       useValue: APP_MOMENT_DATE_FORMATS
//     },
//     {
//       provide: MAT_DATE_LOCALE,
//       useValue: locale
//     },
//     {
//       provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
//       useValue: {
//         strict: true,
//         useUtc: false
//       }
//     }
//   ];
// }

// Flexible provider function (choose adapter type)
export function provideDateConfiguration(
  locale: string = 'en-US',
  adapterType: DateAdapterType = 'native'
): Provider[] {
  //console.log(`🔧 Setting up ${adapterType} date adapter`);

  // if (adapterType === 'moment') {
  //   return provideMomentDateConfiguration(locale);
  // } else {
    return provideNativeDateConfiguration(locale);
  //}
}

export const DATE_MODULE_PROVIDERS = provideNativeDateConfiguration('en-US');

export const APP_DATE_FORMATS = APP_NATIVE_DATE_FORMATS;

/**
 * @deprecated Use APP_NATIVE_DATE_FORMATS.
 */
export const BITS_NATIVE_DATE_FORMATS = APP_NATIVE_DATE_FORMATS;
